/**
 * The API serialises UTC timestamps without a time-zone designator, which the browser would
 * otherwise read as local time. Treat a value without one as UTC.
 */
const parseApiDate = (value: string | Date): Date => {
  if (value instanceof Date) return value;
  return new Date(/([zZ]|[+-]\d{2}:?\d{2})$/.test(value) ? value : `${value}Z`);
};

export const formatDate = (value: string | Date): string =>
  parseApiDate(value).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });

export const formatDateTime = (value: string | Date): string =>
  parseApiDate(value).toLocaleString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

/** Contract dates are calendar dates (no time part), so they must not be shifted by time zone. */
export const formatCalendarDate = (value: string | Date): string =>
  new Date(value).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
